import { getUnreadCount } from "@/api/notices";

/**
 * Сводка непрочитанного: число и последнее непрочитанное уведомление.
 * Если сервер ещё без GET /api/notifications/unread-summary, берёт только
 * число из старого запроса unread-count.
 * @returns {Promise<{count: number, latest: object|null}>}
 */
export const getUnreadSummary = async () => {
  const response = await fetch("/api/notifications/unread-summary", {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });

  if (response.status === 404) {
    return { count: await getUnreadCount(), latest: null };
  }

  const data = await response.json();

  if (!response.ok || data.error) {
    throw new Error(
      `Ошибка при получении данных. ${data.error || "Обновите страницу"}`
    );
  }

  return { count: Number(data.count) || 0, latest: data.latest || null };
};
